export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9286.b4a9aa9f.jpg";